import { watch, watchEffect, ref } from 'vue'

export function useValidatorError(validator, property) {
  const data = ref(null)

  function getError() {
    const { $dirty, $errors, $invalid } = validator.value?.[property] ?? {
      $dirty: null,
      $errors: null,
      $invalid: null,
    }

    if ($dirty && $invalid) {
      data.value = $errors[0].$message
    } else {
      data.value = null
    }
  }

  watchEffect(getError)

  return data
}

export function useGraphQlError(errors, property) {
  const data = ref(undefined)

  function getError() {
    const hasProperty = errors.value?.hasOwnProperty(`input.${property}`) ?? false
    if (hasProperty) {
      const [val] = errors.value[`input.${property}`]
      data.value = val
    } else {
      data.value = undefined
    }
  }

  watchEffect(getError)

  return data
}

export function useValidatorWithGraphQlError(v$, errors, validatorProperty, graphQlProperty) {
  const data = ref(null)

  const validatorErrorData = useValidatorError(v$, validatorProperty)
  const graphQlErrorData = useGraphQlError(errors, graphQlProperty)

  watch([validatorErrorData, graphQlErrorData], (newVal, oldVal) => {
    const [newValidatorVal, newGraphQlVal] = newVal
    const [oldValidatorVal, oldGraphQlVal] = oldVal

    // with this ordering we are favoring graphql validation errors
    if (newGraphQlVal !== oldGraphQlVal) {
      data.value = newGraphQlVal
    } else if (newValidatorVal !== oldValidatorVal) {
      data.value = newValidatorVal
    } else {
      data.value = null
    }
  })

  return data
}
